"use client";

import { useAxios } from "@/app/providers/AxiosProvider";
import { useMutation } from "@tanstack/react-query";

export default function useCVUpload() {
  const api = useAxios();
  return useMutation({
    mutationFn: async ({ file, fileId }) => {
      const formData = new FormData();
      formData.append("file_id", fileId);
      formData.append("resume_file", file);

      const res = await api.post("/candidate/create/resume", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      return res.data;
    },
  });
}
